<p class="c-title">Mostrar por:</p>
<div class="c-checkbox-container">
  <mat-checkbox class="c-checkbox-container__checkbox" *ngFor="let coluna of colunasTabela"
    [(ngModel)]="coluna.ativa">{{coluna.descricao}}</mat-checkbox>
</div>